import { render } from "./ActivityAttachmentImageModal.vue?vue&type=template&id=446d3f8a&scoped=true&ts=true"
import script from "./ActivityAttachmentImageModal.ts?vue&type=script&lang=ts"
export * from "./ActivityAttachmentImageModal.ts?vue&type=script&lang=ts"

import "./ActivityAttachmentImageModal.scss?vue&type=style&index=0&id=446d3f8a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-446d3f8a"]])

export default __exports__